import { showErrorToast } from 'shared/lib/notifications';

import { DEFAULT_ERROR_MESSAGE, isErrorsModel, isAxiosResponseError } from './errors';
import type { ErrorsModel } from './model';

type HandleErrorParams = {
  error: unknown;
  getErrorMessage: (errors: ErrorsModel) => string;
  showError?: (errorMessage: string) => void;
};

export function handleError({ error, getErrorMessage, showError }: HandleErrorParams) {
  let errorMessage = DEFAULT_ERROR_MESSAGE;

  if (isErrorsModel(error)) {
    errorMessage = getErrorMessage(error);
  } else if (isAxiosResponseError(error)) {
    errorMessage = getErrorMessage(error.response.data);
  }

  if (showError) {
    showError(errorMessage);
  } else {
    showErrorToast(errorMessage);
  }
}
